// src/components/FICS/PublishedOverlaps.js
import React from 'react';
import { 
  Title, 
  Text, 
  Paper, 
  Stack, 
  Group, 
  ThemeIcon, 
  Badge, 
  useMantineTheme,
  useMantineColorScheme
} from '@mantine/core';
import { IconFileInfo } from '@tabler/icons-react';

const getDistanceColor = (distance) => {
  if (distance < 0.3) return 'red';
  if (distance < 0.5) return 'orange';
  if (distance < 0.7) return 'yellow';
  return 'blue.3';
};

function PublishedOverlaps({ data }) {
  const theme = useMantineTheme();
  // const { colorScheme } = useMantineColorScheme(); // Not strictly needed if badges adapt by default
  // const isDarkGlobal = colorScheme === 'dark'; // Not strictly needed if badges adapt by default

  const primaryTextColorOnIsland = theme.black;
  const secondaryTextColorOnIsland = theme.colors.gray[7];
  const dimmedTextColorOnIsland = theme.colors.gray[6];
  const islandBgColor = theme.colors.gray[4]; // Your preferred fixed light grey

  if (!data || data.length === 0) {
    return (
      <Paper withBorder p="md" radius="md" mt="md" bg={islandBgColor}>
        <Group>
          <ThemeIcon color="green" size="lg" radius="md">
            <IconFileInfo size="1.5rem" />
          </ThemeIcon>
          <div>
            <Text fw={500} c={primaryTextColorOnIsland}>
              01 | Published History Check
            </Text>
            <Text size="sm" c={dimmedTextColorOnIsland}>
              Clear! No highly similar articles found in our published history.
            </Text>
          </div>
        </Group>
      </Paper>
    );
  }

  return (
    <Paper withBorder p="lg" radius="md" mt="xl" bg={islandBgColor}>
      <Title order={2} mb="lg" c={primaryTextColorOnIsland}>
        01 | Published History Check
      </Title>
      <Text size="md" c={secondaryTextColorOnIsland} mb="lg">
        Similar articles found in our published history:
      </Text>
      <Stack gap="md">
        {data.map((item) => {
          const similarityPercentage = Math.round((1 - item.distance) * 100);
          const badgeBaseColorName = getDistanceColor(item.distance);
          
          // No special styles needed for the badge anymore; let variant="light" adapt.
          // let badgeStylesToApply = {}; 
          // if (isDarkGlobal) { ... }

          return (
            <Paper key={item.id} withBorder p="md" radius="sm" shadow="xs" bg={theme.colors.dark[5]}>
              <Group justify="space-between">
                <Stack gap={0}>
                  <Text c={theme.white} fw={500} lineClamp={2}>{item.title}</Text>
                  <Text size="xs" c="dimmed">ID: {item.id}</Text>
                </Stack>
                <Badge
                  color={badgeBaseColorName}
                  variant="light" // This will naturally adapt to light/dark mode
                  size="lg"
                  // styles={badgeStylesToApply} // No longer applying overrides here
                >
                  Similarity: {similarityPercentage}%
                </Badge>
              </Group>
            </Paper>
          );
        })}
      </Stack>
    </Paper>
  );
}

export default PublishedOverlaps;